import { ArrowDown, ArrowUp } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { Button } from '../../components/button/Button'
import { Status } from '../../components/cards/statusTag'
import { ListMenuItem } from '../../redux-toolkits/list-menu/listMenu.types'

interface Props {
  menu: ListMenuItem
  isFirst: boolean
  isLast: boolean
  isReordering: boolean
  onMoveUp: () => void
  onMoveDown: () => void
}

export const ListMenuCard = ({
  menu,
  isFirst,
  isLast,
  isReordering,
  onMoveUp,
  onMoveDown,
}: Props) => {
  const navigate = useNavigate()

  return (
    <div className="border border-divider-gray rounded-xl bg-white overflow-hidden">
      <div className="flex items-start gap-3 p-5">
        <div className="flex flex-col gap-0.5 shrink-0 pt-0.5">
          <button
            onClick={onMoveUp}
            disabled={isFirst || isReordering}
            className="p-1.5 rounded hover:bg-gray-bg disabled:opacity-30 disabled:cursor-not-allowed transition-colors text-sec-black hover:text-black"
          >
            <ArrowUp size={14} />
          </button>
          <button
            onClick={onMoveDown}
            disabled={isLast || isReordering}
            className="p-1.5 rounded hover:bg-gray-bg disabled:opacity-30 disabled:cursor-not-allowed transition-colors text-sec-black hover:text-black"
          >
            <ArrowDown size={14} />
          </button>
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap mb-1">
            <span className="font-medium text-lg text-black">{menu.name}</span>

            <Status
              type={menu.isActive ? 'success' : 'warn'}
              text={menu.isActive ? 'Published' : 'Draft'}
              className="!text-xs"
            />
          </div>
          <p className="text-sm text-sec-black line-clamp-1">
            {menu.description}
          </p>
          <p className="mt-1 text-xs text-sec-black">
            {menu.listCount ?? 0} published{' '}
            {menu.listCount === 1 ? 'list' : 'lists'}
          </p>
        </div>

        <Button
          label="Edit"
          size="small"
          variant="border-grey"
          onClick={() => navigate(`/channel-curation/nav-menu/${menu._id}`)}
        />
      </div>
    </div>
  )
}
